import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, Truck } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const LogisticsHero = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="relative pt-32 pb-24 px-6 overflow-hidden">
      <div className="relative z-20 max-w-7xl mx-auto">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-4 leading-tight text-white">
            Keep Operations Moving.
          </h1>
          
          <p className="text-2xl md:text-3xl text-cyan-400 font-semibold mb-8">
            Train the People Who Keep Freight Moving.
          </p>

          <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-4xl mx-auto leading-relaxed">
            Traain helps logistics and trucking organizations build consistent, safety-focused, high-performing teams — across terminals, fleets, and shifts.
          </p>

          <p className="text-xl text-gray-300 font-semibold mb-4">
            All Aboard Operational Readiness
          </p>
          
          <p className="text-lg text-cyan-400 font-semibold mb-12">
            Powered by Traain's Navigator AI™
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              size="lg"
              onClick={openCalendly}
              className="h-14 bg-cyan-500 text-black hover:bg-cyan-400 rounded-lg px-8 text-lg font-semibold transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
              data-testid="logistics-hero-demo-btn"
            >
              <Truck className="w-5 h-5 mr-2" />
              See Traain for Logistics & Trucking
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default LogisticsHero;
